<template>
  <v-row v-if="command">
    <div v-for="(item, index) in buttons" :key="index" :name="index">
      <v-tooltip bottom v-if="canShow(item)">
        <template v-slot:activator="{ on }">
          <v-icon @click="click(item)" :color="item.color" dark v-on="on">{{item.icon}}</v-icon>
        </template>
        <span>{{item.tooltip}}</span>
      </v-tooltip>
    </div>
  </v-row>
</template>

<script>
var buttons = [
  {
    id: "edit",
    showFor: ["New"],
    icon: "mdi-playlist-edit",
    color: "primary",
    tooltip: "Upraviť",
    text: "Upraviť",
    emit: "edit-click"
  },
  {
    id: "detail",
    showFor: ["InProgress", "Done", "Canceled"],
    icon: "mdi-ballot-outline",
    color: "info",
    tooltip: "Stav vo výrobe",
    text: "Stav vo výrobe",
    emit: "detail-click"
  },
  {
    id: "confirm",
    showFor: ["New"],
    icon: "mdi-arrow-right-bold-box",
    color: "success",
    tooltip: "Zadať do výroby",
    text: "Zadať do výroby",
    emit: "confirm-click",
    alertMessage: "Naozaj chcete zadať príkaz do výroby?"
  },
  // {
  //   id: "cancel",
  //   showFor: ["New"],
  //   icon: "mdi-close-circle",
  //   color: "error",
  //   tooltip: "Zrušiť výrobný príkaz",
  //   text: "Zrušiť výrobný príkaz",
  //   emit: "cancel-click",
  //   alertMessage: "Naozaj chcete zrušiť výrobný príkaz?"
  // },
  {
    id: "delete",
    showFor: ["New"],
    icon: "mdi-close-circle",
    color: "error",
    tooltip: "Zmazať výrobný príkaz",
    text: "Zmazať výrobný príkaz",
    emit: "delete-click",
    alertMessage: "Naozaj chcete zmazať výrobný príkaz?"
  }
];

export default {
  name: "CommandButtonGroup",
  props: {
    command: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      buttons: buttons
    };
  },

  methods: {
    canShow(item) {
      if (item.showFor.includes(this.command.manufacturingCommandStatus)) {
        return true;
      } else {
        return false;
      }
    },
    click(item) {
      if (item.alertMessage) {
        if (confirm(item.alertMessage)) {
          this.returnValue(item);
        }
      } else {
        this.returnValue(item);
      }
    },
    returnValue(item) {
      console.log(item.emit);
      this.$emit(item.emit, this.command);
    }
  }
};
</script>
